import { useEffect, useState } from 'react'
import { Wapprunner } from '../wapprunner'
import { addToWappPool } from '../../wapprunner-pool/wapprunnerPool.ops'
import { WappSessionCreator } from '../../common'

export const WapprunnerCreate = ({
  wappSessionId: initialWappSessionId,
  wappId,
  wisId,
  mode,
  input,
  parentWapp,
}: WappSessionCreator) => {
  const [wappSessionId, setWappSessionId] = useState<string>(null)

  useEffect(() => {
    const initiateWapp = async () => {
      const sessionId = await addToWappPool({
        wappSessionId: initialWappSessionId,
        wappId,
        wisId,
        input,
        mode,
        parentWapp,
      })

      setWappSessionId(sessionId)
      return sessionId
    }

    initiateWapp()
  }, [])

  return wappSessionId ? (
    <Wapprunner key={wappSessionId} wappSessionId={wappSessionId} />
  ) : null
}

WapprunnerCreate.defaultProps = {
  wisId: undefined,
  input: null,
  parentWapp: null,
}
